export default __webpack_public_path__ + "static/media/four.9c465a65.jpg";